import {
  DocumenterActionTypes,
  DocumenterRunClearedPayload,
  DocumenterRunCompletedPayload,
  DocumenterRunFailedPayload,
  DocumenterRunProgressPayload
} from './types'

export const documenterRunProgress = (payload: DocumenterRunProgressPayload) => ({
  type: DocumenterActionTypes.RUN_PROGRESS,
  payload
})

export const documenterRunCompleted = (payload: DocumenterRunCompletedPayload) => ({
  type: DocumenterActionTypes.RUN_COMPLETED,
  payload
})

export const documenterRunFailed = (payload: DocumenterRunFailedPayload) => ({
  type: DocumenterActionTypes.RUN_FAILED,
  payload
})

export const documenterRunCleared = (payload: DocumenterRunClearedPayload) => ({
  type: DocumenterActionTypes.RUN_CLEARED,
  payload
})
